"use strict";
/**
 * Created by Aram.Nurijanyan on 19/03/2018
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var framework_service_1 = require("./framework.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var path_helper_1 = require("./config/path.helper");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var operators_1 = require("rxjs/operators");
var if_service_1 = require("./if.service");
var from_1 = require("rxjs/observable/from");
var http_1 = require("@angular/common/http");
var HttpFrameworkService = /** @class */ (function (_super) {
    __extends(HttpFrameworkService, _super);
    function HttpFrameworkService(http, applicationPropertiesService, entitySearchService, iFService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.entitySearchService = entitySearchService;
        _this.iFService = iFService;
        _this.meServiceUriKey = "me-de-service-url";
        _this.meServiceUri$ = from_1.from(_this.applicationPropertiesService.getProperty(_this.meServiceUriKey));
        return _this;
    }
    HttpFrameworkService.prototype.getFramework = function (frameworkId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK + ("" + frameworkId)); }));
    };
    HttpFrameworkService.prototype.getFrameworks = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK); }));
    };
    HttpFrameworkService.prototype.getFrameworkByIFSystemNameAndIFItemId = function (iFSystemName, iFItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK + iFSystemName + '/' + iFItemId); }));
    };
    HttpFrameworkService.prototype.getFrameworksByIFSystemNameAndIFItemId = function (systemName, itemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORKS + systemName + "/" + itemId); }));
    };
    HttpFrameworkService.prototype.attachFrameworks = function (systemName, itemId, frameworkIds) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORKS + systemName + "/" + itemId, frameworkIds); }));
    };
    HttpFrameworkService.prototype.deleteAttachedFramework = function (systemName, itemId, frameworkId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORKS + systemName + "/" + itemId + "/" + frameworkId); }));
    };
    HttpFrameworkService.prototype.getFrameworksByTypeId = function (typeId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK, { params: { 'tId': "" + typeId } }); }));
    };
    HttpFrameworkService.prototype.getGlobalFrameworks = function () {
        return this.getFrameworksByTypeId(1);
    };
    HttpFrameworkService.prototype.getCorporateFrameworks = function () {
        return this.getFrameworksByTypeId(1);
    };
    HttpFrameworkService.prototype.getSpecificFrameworks = function () {
        return this.getFrameworksByTypeId(2);
    };
    HttpFrameworkService.prototype.createFramework = function (framework) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK, framework); }));
    };
    HttpFrameworkService.prototype.createFrameworkByIFSystemNameAndIFItemId = function (framework, iFSystemName, iFItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK + iFSystemName + '/' + iFItemId, framework); }));
    };
    HttpFrameworkService.prototype.updateFramework = function (framework, iFSystemName, iFItemId) {
        var _this = this;
        if (iFSystemName && iFItemId) {
            return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK, framework, {
                params: {
                    'if-system-name': "" + iFSystemName,
                    'if-item-id': "" + iFItemId
                }
            }); }));
        }
        else {
            return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK, framework); }));
        }
    };
    HttpFrameworkService.prototype.deleteFramework = function (frameworkId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) {
            return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK + frameworkId);
        });
    };
    HttpFrameworkService.prototype.getFTreeByIFSystemNameAndIFItemId = function (frameworkId, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK + ("tree/" + frameworkId + "/" + systemName + "/" + ifItemId)); });
    };
    HttpFrameworkService.prototype.getFTree = function (frameworkId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.FRAMEWORK + ("tree/" + frameworkId)); });
    };
    HttpFrameworkService.prototype.saveFTreeByIFSystemNameAndIFItemId = function (fTree, systemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK + ("tree/" + systemName + "/" + ifItemId), fTree); });
    };
    HttpFrameworkService.prototype.saveFTree = function (fTree) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK + 'tree', fTree); });
    };
    HttpFrameworkService.prototype.createFItem = function (rfId, frameworkItem, iFSystemName, iFItemId) {
        var _this = this;
        if (iFSystemName && iFItemId) {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + frameworkItem.level + '/items', frameworkItem, { params: { 'if-system-name': "" + iFSystemName, 'if-item-id': "" + iFItemId } }); });
        }
        else {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + frameworkItem.level + '/items', frameworkItem); });
        }
    };
    HttpFrameworkService.prototype.updateFItem = function (rfId, frameworkItem, iFSystemName, iFItemId) {
        var _this = this;
        if (iFSystemName && iFItemId) {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + frameworkItem.level + '/items/' + frameworkItem.id, frameworkItem, { params: { 'if-system-name': iFSystemName, 'if-item-id': iFItemId + '' } }); });
        }
        return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + frameworkItem.level + '/items/' + frameworkItem.id, frameworkItem); });
    };
    HttpFrameworkService.prototype.updateIFItem = function (rfId, level, rFItemId, body, orderNumber) {
        var _this = this;
        if (orderNumber > 0) {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + '/' + rfId + '/' + level + '/' + rFItemId, body, { params: { 'order-number': "" + orderNumber } }); });
        }
        else {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.put(url + '/' + rfId + '/' + level + '/' + rFItemId, body); });
        }
    };
    HttpFrameworkService.prototype.deleteFItem = function (rfId, levelNumber, itemId, iFSystemName, iFItemId) {
        var _this = this;
        if (iFSystemName) {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + levelNumber + '/items/' + itemId, { params: { 'if-system-name': "" + iFSystemName } }); });
        }
        else {
            return this.meServiceUri$.flatMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.FRAMEWORK + rfId + '/level/' + levelNumber + '/items/' + itemId); });
        }
    };
    HttpFrameworkService.prototype.getRFItemsByLevel = function (levelNumber) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + '/rf-items/level/' + levelNumber); });
    };
    HttpFrameworkService.prototype.reorderAttachedIndicator = function (rfId, rfItemId, rfLevel, iFSystemName, iFItemId, orderNumber, indicatorId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) {
            url += path_helper_1.PathHelper.FRAMEWORK_INDICATORS;
            if (!rfId) {
                url += iFSystemName + "/" + iFItemId + "/" + indicatorId;
            }
            else if (!iFSystemName) {
                url += rfId + "/" + rfItemId + "/" + rfLevel + "/" + indicatorId;
            }
            else {
                url += rfId + "/" + rfItemId + "/" + rfLevel + "/" + iFSystemName + "/" + iFItemId + "/" + indicatorId;
            }
            return _this.http.put(url, {}, { params: { 'order-number': "" + orderNumber } });
        });
    };
    HttpFrameworkService.prototype.getIndicatorsForResultArea = function (rfId, rfItemId, rfLevel) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) {
            url += path_helper_1.PathHelper.FRAMEWORK_INDICATORS;
            url += rfId + "/" + rfItemId + "/" + rfLevel;
            return _this.http.get(url);
        });
    };
    HttpFrameworkService.prototype.reorderIFItems = function (rfId, rfItemId, rfLevel, iFSystemName, iFItemId, orderNumber) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) {
            url += "" + path_helper_1.PathHelper.FRAMEWORK + rfId + "/" + rfLevel + "/" + rfItemId + "/" + iFSystemName + "/" + iFItemId;
            return _this.http.put(url, {}, { params: { 'order-number': "" + orderNumber } });
        });
    };
    HttpFrameworkService.prototype.getRFItemLinks = function (linkModel, languageId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.flatMap(function (url) { return _this.http.get(url + '/framework-item/links?' + linkModel.getQuery(languageId)); }))
            .pipe(operators_1.flatMap(function (res) {
            if (res.some(function (i) { return i.ifItemId; })) {
                return _this.iFService.getIFStructures().pipe(operators_1.map(function (structures) {
                    res.forEach(function (i) {
                        if (i.ifItemId && i.ifSystemName) {
                            var _a = structures.find(function (j) { return j.systemName === i.ifSystemName; }), nameFieldKey_1 = _a.nameFieldKey, instanceIdFieldName = _a.instanceIdFieldName;
                            var filter = new idm_de_core_frontend_1.FilterBuilder().in(instanceIdFieldName, [i.ifItemId]).buildJson();
                            i.frameworkName = _this.entitySearchService.loadPortfolioItemsByFields(i.ifSystemName, new idm_de_core_frontend_1.PagingOptions(0, 10000), new idm_de_core_frontend_1.SortingOptions(nameFieldKey_1 + "." + languageId, idm_de_core_frontend_1.SortType.ASC), filter, null, null, [nameFieldKey_1, instanceIdFieldName]).pipe(operators_1.map(function (ifs) {
                                return ifs.getData()[0].getProperty(nameFieldKey_1).value.getValue(languageId);
                            }));
                        }
                        else {
                            i.frameworkName = Observable_1.Observable.of(i.frameworkName);
                        }
                    });
                    return res;
                }));
            }
            else {
                res.forEach(function (i) {
                    i.frameworkName = Observable_1.Observable.of(i.frameworkName);
                });
                return Observable_1.Observable.of(res);
            }
        }));
    };
    HttpFrameworkService.prototype.linkRFItem = function (linkTo, links) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.post(url + '/framework-item/links', {
            linkTo: linkTo.getParams(),
            links: links.map(function (link) {
                return link.getParams();
            })
        }); });
    };
    HttpFrameworkService.prototype.unlinkRFItem = function (id) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.delete(url + '/framework-item/links/' + id); });
    };
    HttpFrameworkService.prototype.getLevelStructures = function () {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORK + 'level-structures'); });
    };
    HttpFrameworkService.prototype.getItemsBySystemName = function (systemName) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORK + systemName + '/items'); });
    };
    HttpFrameworkService.prototype.getIFIndicators = function (ifSystemName, ifItemId) {
        var _this = this;
        return this.meServiceUri$.flatMap(function (url) { return _this.http.get(url + "/" + path_helper_1.PathHelper.IMPLEMENTATION_FRAMEWORK + "/" + ifSystemName + "/items/" + ifItemId + "/indicators"); });
    };
    HttpFrameworkService.prototype.getResultFrameworkItems = function (parentCategorySystemName, parentCategoryItemId, categorySystemName, languageId, sort) {
        var _this = this;
        if (sort === void 0) { sort = 'ASC'; }
        var params = new http_1.HttpParams().set('language', languageId.toString()).set('sort', sort);
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + "/" + parentCategorySystemName + "/" + parentCategoryItemId + "/" + categorySystemName, {
                params: params,
            });
        }));
    };
    HttpFrameworkService.prototype.assignIFToRF = function (frameworkId, level, itemId, body) {
        var _this = this;
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + "/" + frameworkId + "/" + level + "/" + itemId, JSON.stringify(body), {
                headers: headers,
            });
        }));
    };
    HttpFrameworkService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_entity_search_client_js_1.EntitySearchService,
            if_service_1.IFService])
    ], HttpFrameworkService);
    return HttpFrameworkService;
}(framework_service_1.FrameworkService));
exports.HttpFrameworkService = HttpFrameworkService;
//# sourceMappingURL=http-framework.service.js.map